/* eslint react/display-name: 0 */
import React, { useEffect } from "react";
import { object, bool, func, element, node, oneOfType } from "prop-types";
import { connect } from "react-redux";

import { compose } from "../helpers";
import history from "../history";

import { setModalState } from "../redux/actions";

import { Modal } from "../common";

const withOpenModal =
  (Component) =>
  ({ ...props }) => {
    useEffect(() => {
      props.setModalState(true);
    }, []);
    return <Component {...props} />;
  };

const withProfileEditProps =
  (Component) =>
  ({ ...props }) =>
    (
      <Component
        {...props}
        onModalClose={() => {
          if (/royal-mail-onboarding\/\w+/.test(document.location.pathname)) {
            history.push("/profile/edit/royal-mail-onboarding");
          } else {
            props.setModalState(false);
            history.push("/profile");
          }
        }}
      />
    );

const ProfileEdit = ({ appData, isOpenModal, onModalClose, children }) =>
  !appData ? (
    <div />
  ) : (
    <div style={{ position: "relative", height: 1000, background: "white" }}>
      <Modal
        isOpen={isOpenModal}
        onClose={onModalClose}
        style={{ top: 0, zIndex: 10000 }}
      >
        {children}
      </Modal>
    </div>
  );

ProfileEdit.propTypes = {
  children: oneOfType([node.isRequired, element.isRequired]),
  appData: object,
  isOpenModal: bool.isRequired,
  onModalClose: func.isRequired,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
  loading: state.core.loading,
  isOpenModal: state.core.isOpenModal,
});

const mapDispatchToProps = { setModalState };

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const withApi = compose(withRedux, withProfileEditProps, withOpenModal);

export default withApi(ProfileEdit);
